import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Paper,
    Typography,
    Button,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Snackbar,
    Tabs,
    Tab,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Grid
} from "@material-ui/core";
import {
    FileCopy,
    Refresh,
    Delete,
    Add,
    Code,
    Description,
    ExpandMore
} from "@material-ui/icons";
import MuiAlert from "@material-ui/lab/Alert";
import api from "../../services/api";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(2),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 600,
    },
    subtitle: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(3),
    },
    codeBlock: {
        backgroundColor: "#f5f5f5",
        padding: theme.spacing(2),
        borderRadius: 4,
        fontFamily: "monospace",
        fontSize: 13,
        overflowX: "auto",
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
        whiteSpace: "pre-wrap",
        wordBreak: "break-all"
    },
    methodChip: {
        fontWeight: "bold",
        marginRight: theme.spacing(1)
    },
    endpointPath: {
        fontFamily: "monospace",
        fontSize: 14
    },
    tryButton: {
        marginTop: theme.spacing(2)
    }
}));

const ApiDzapy = () => {
    const classes = useStyles();
    const [tokens, setTokens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [tokenName, setTokenName] = useState("");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [tabValue, setTabValue] = useState(0);
    const [testResults, setTestResults] = useState({});

    // Detectar URL do backend corretamente (api6 ao invés de app6)
    const getBackendUrl = () => {
        if (process.env.REACT_APP_BACKEND_URL) {
            return process.env.REACT_APP_BACKEND_URL;
        }

        const currentHost = window.location.host;
        
        if (currentHost.startsWith('wpp.')) {
            return window.location.protocol + '//' + currentHost.replace(/^wpp\./, 'wppapi.');
        }

        if (currentHost.startsWith('app')) {
            return window.location.protocol + '//' + currentHost.replace(/^app/, 'api');
        }

        return window.location.origin;
    };

    const backendUrl = getBackendUrl();

    const endpoints = [
        {
            category: "Envio Individual",
            items: [
                {
                    method: "POST",
                    path: "/api/send/text",
                    title: "Enviar mensagem de texto",
                    description: "Envia uma mensagem de texto simples para um número WhatsApp",
                    example: {
                        whatsappid: "1",
                        number: "5531985294349",
                        text: "Olá! Como posso ajudar?"
                    }
                },
                {
                    method: "POST",
                    path: "/api/send/image",
                    title: "Enviar imagem",
                    description: "Envia uma imagem com legenda opcional",
                    example: {
                        whatsappid: "1",
                        number: "5531985294349",
                        file: "https://picsum.photos/800/600",
                        text: "Confira esta imagem!"
                    }
                },
                {
                    method: "POST",
                    path: "/api/send/file",
                    title: "Enviar arquivo/documento",
                    description: "Envia um arquivo ou documento PDF, DOC, etc",
                    example: {
                        whatsappid: "1",
                        number: "5531985294349",
                        file: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
                        docName: "documento.pdf",
                        text: "Segue o documento"
                    }
                }
            ]
        },
        {
            category: "Mensagens Interativas",
            items: [
                {
                    method: "POST",
                    path: "/api/send/button",
                    title: "Enviar botões interativos",
                    description: "Envia até 3 botões clicáveis",
                    example: {
                        whatsappid: "1",
                        number: "5531985294349",
                        type: "button",
                        text: "Escolha uma opção:",
                        imageButton: "https://picsum.photos/400/300",
                        choices: ["Opção 1", "Opção 2", "Opção 3"],
                        footerText: "Escolha sabiamente"
                    }
                },
                {
                    method: "POST",
                    path: "/api/send/list",
                    title: "Enviar lista de opções",
                    description: "Envia uma lista com até 10 opções",
                    example: {
                        whatsappid: "1",
                        number: "5531985294349",
                        type: "list",
                        text: "Escolha um produto:",
                        listButton: "Ver opções",
                        choices: ["Produto A", "Produto B", "Produto C", "Produto D"]
                    }
                },
                {
                    method: "POST",
                    path: "/api/send/carousel",
                    title: "Enviar carrossel de produtos",
                    description: "Envia um carrossel com múltiplos cards",
                    example: {
                        whatsappid: "1",
                        number: "5531985294349",
                        text: "Confira nossos produtos:",
                        carousel: [
                            {
                                text: "Produto 1 - R$ 99,90",
                                image: "https://picsum.photos/400/400?random=1",
                                buttons: [
                                    { id: "BTN_1", text: "Comprar", type: "REPLY" },
                                    { id: "BTN_2", text: "Mais info", type: "REPLY" }
                                ]
                            },
                            {
                                text: "Produto 2 - R$ 149,90",
                                image: "https://picsum.photos/400/400?random=2",
                                buttons: [
                                    { id: "BTN_3", text: "Comprar", type: "REPLY" }
                                ]
                            }
                        ]
                    }
                }
            ]
        },
        {
            category: "Envio em Massa",
            items: [
                {
                    method: "POST",
                    path: "/api/sender/advanced",
                    title: "Envio em massa (RECOMENDADO)",
                    description: "Envia múltiplas mensagens de forma assíncrona. Ideal para campanhas.",
                    example: {
                        whatsappid: "1",
                        delayMin: 30,
                        delayMax: 300,
                        info: "Minha Campanha de Vendas",
                        messages: [
                            { number: "5531111111111", type: "text", text: "Olá! Confira nossa oferta." },
                            { number: "5531222222222", type: "image", file: "https://exemplo.com/promo.jpg", text: "Imagem da Oferta" }
                        ]
                    }
                }
            ]
        },
        {
            category: "Gerenciamento",
            items: [
                {
                    method: "GET",
                    path: "/api/sender/queue?whatsappid=1",
                    title: "Visualizar fila de envios",
                    description: "Lista todos os envios em andamento"
                },
                {
                    method: "GET",
                    path: "/api/sender/folder/{folderId}?whatsappid=1",
                    title: "Consultar status de envio",
                    description: "Retorna estatísticas de um envio específico"
                },
                {
                    method: "POST",
                    path: "/api/sender/control/{folderId}",
                    title: "Controle de campanha",
                    description: "Pausa, retoma ou deleta uma campanha de envio em massa",
                    example: {
                        whatsappid: "1",
                        action: "stop" // Valores: stop, continue, delete
                    }
                }
            ]
        },
        {
            category: "Instância",
            items: [
                {
                    method: "POST",
                    path: "/api/instance/qrcode",
                    title: "Gerar QR Code",
                    description: "Gera QR Code para conectar a instância WhatsApp",
                    example: {
                        whatsappid: "1"
                    }
                },
                {
                    method: "GET",
                    path: "/api/status",
                    title: "Verificar status da conexão",
                    description: `Verifica se o número WhatsApp está conectado à instância. Retorna o estado atual da conexão e informações do perfil.

Estados possíveis (connectionState):
• connected    → Conectado e autenticado com sucesso
• connecting   → Em processo de conexão (aguardando QR code ou paircode)
• disconnected → Desconectado do WhatsApp
• hibernated   → Sessão pausada com credenciais preservadas

Atenção: este endpoint usa autenticação JWT (Bearer token), não o token de API.`,
                    responseExample: {
                        isConnected: true,
                        connectionState: "connected",
                        loggedIn: true,
                        phoneNumber: "5531985294349@s.whatsapp.net",
                        profileName: "Empresa ABC",
                        profilePicUrl: "https://example.com/profile.jpg",
                        qrcode: null,
                        paircode: null,
                        lastDisconnect: null,
                        lastDisconnectReason: null
                    }
                }
            ]
        },
        {
            category: "Validação de Número",
            items: [
                {
                    method: "GET",
                    path: "/api/whatsappnumber/{number}/{whatsappid}",
                    title: "Verificar se o número possui WhatsApp",
                    description: `Verifica se o número de telefone fornecido está registrado no WhatsApp. Retorna "sim" ou "não" de forma clara.`,
                    responseExample: {
                        exists: "sim",
                        jid: "5531985294349@s.whatsapp.net",
                        number: "5531985294349",
                        whatsappId: 24,
                        details: {
                            query: "5531985294349",
                            jid: "5531985294349@s.whatsapp.net",
                            lid: "123456789@lid",
                            isInWhatsapp: true,
                            verifiedName: "",
                            groupName: "",
                            error: ""
                        }
                    }
                }
            ]
        }
    ];

    useEffect(() => {
        fetchTokens();
    }, []);

    const fetchTokens = async () => {
        try {
            setLoading(true);
            const { data } = await api.get("/api-tokens");
            setTokens(data);
        } catch (error) {
            console.error("Error fetching tokens:", error);
            showSnackbar("Erro ao carregar tokens", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleCreateToken = async () => {
        if (!tokenName.trim()) {
            showSnackbar("Nome do token é obrigatório", "error");
            return;
        }

        try {
            await api.post("/api-tokens", { name: tokenName });
            showSnackbar("Token criado com sucesso!", "success");
            setOpenDialog(false);
            setTokenName("");
            fetchTokens();
        } catch (error) {
            console.error("Error creating token:", error);
            showSnackbar("Erro ao criar token", "error");
        }
    };

    const handleCopyToken = (token) => {
        navigator.clipboard.writeText(token);
        showSnackbar("Token copiado para área de transferência!", "success");
    };

    const handleCopyExample = (example) => {
        navigator.clipboard.writeText(JSON.stringify(example, null, 2));
        showSnackbar("Exemplo copiado!", "success");
    };

    const handleRegenerateToken = async (id) => {
        if (!window.confirm("Tem certeza que deseja regenerar este token? O token antigo será invalidado.")) {
            return;
        }

        try {
            await api.put(`/api-tokens/${id}/regenerate`);
            showSnackbar("Token regenerado com sucesso!", "success");
            fetchTokens();
        } catch (error) {
            console.error("Error regenerating token:", error);
            showSnackbar("Erro ao regenerar token", "error");
        }
    };

    const handleRevokeToken = async (id) => {
        if (!window.confirm("Tem certeza que deseja revogar este token?")) {
            return;
        }

        try {
            await api.delete(`/api-tokens/${id}`);
            showSnackbar("Token revogado com sucesso!", "success");
            fetchTokens();
        } catch (error) {
            console.error("Error revoking token:", error);
            showSnackbar("Erro ao revogar token", "error");
        }
    };

    const showSnackbar = (message, severity = "success") => {
        setSnackbar({ open: true, message, severity });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const getMethodColor = (method) => {
        switch (method) {
            case "GET": return "primary";
            case "POST": return "secondary";
            case "PUT": return "default";
            case "DELETE": return "error";
            default: return "default";
        }
    };

    return (
        <MainContainer>
            <MainHeader>
                <Title>API Dzapy</Title>
            </MainHeader>

            <Paper className={classes.mainPaper} variant="outlined">
                <Typography variant="body1" className={classes.subtitle} gutterBottom>
                    Integre o envio de WhatsApp em suas aplicações usando nossa API REST
                </Typography>

                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Gerenciar Tokens" icon={<Code />} />
                    <Tab label="Documentação da API" icon={<Description />} />
                </Tabs>

                {/* Tab 1: Token Management */}
                <TabPanel value={tabValue} index={0}>
                    <Box mt={3}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h6">
                                Seus Tokens de API
                            </Typography>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<Add />}
                                onClick={() => setOpenDialog(true)}
                            >
                                Gerar Novo Token
                            </Button>
                        </Box>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Nome</TableCell>
                                    <TableCell>Token</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Último Uso</TableCell>
                                    <TableCell align="right">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tokens.map((token) => (
                                    <TableRow key={token.id}>
                                        <TableCell>{token.name}</TableCell>
                                        <TableCell>
                                            <code style={{ fontSize: 12 }}>
                                                {token.token.substring(0, 20)}...
                                            </code>
                                        </TableCell>
                                        <TableCell>
                                            {token.isActive ? (
                                                <span style={{ color: "green" }}>✓ Ativo</span>
                                            ) : (
                                                <span style={{ color: "red" }}>✗ Revogado</span>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {token.lastUsedAt
                                                ? new Date(token.lastUsedAt).toLocaleString()
                                                : "Nunca usado"}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Tooltip title="Copiar Token">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleCopyToken(token.token)}
                                                >
                                                    <FileCopy />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Regenerar Token">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleRegenerateToken(token.id)}
                                                >
                                                    <Refresh />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Revogar Token">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleRevokeToken(token.id)}
                                                >
                                                    <Delete />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {tokens.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            Nenhum token criado ainda. Clique em "Gerar Novo Token" para começar.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </TabPanel>

                {/* Tab 2: API Documentation */}
                <TabPanel value={tabValue} index={1}>
                    <Box mt={3}>
                        {tokens.length === 0 && (
                            <Box p={3} bgcolor="#fff3cd" borderRadius={1} mb={2}>
                                <Typography variant="body2" color="textSecondary">
                                    ⚠️ <strong>Atenção:</strong> Você precisa gerar um token na aba "Gerenciar Tokens" antes de usar a API.
                                </Typography>
                            </Box>
                        )}

                        {endpoints.map((category, catIndex) => (
                            <Box key={catIndex} mb={3}>
                                <Typography variant="h6" gutterBottom style={{ marginTop: 20 }}>
                                    {category.category}
                                </Typography>
                                {category.items.map((endpoint, endIndex) => (
                                    <Accordion key={endIndex}>
                                        <AccordionSummary expandIcon={<ExpandMore />}>
                                            <Box display="flex" alignItems="center" width="100%">
                                                <Chip
                                                    label={endpoint.method}
                                                    color={getMethodColor(endpoint.method)}
                                                    size="small"
                                                    className={classes.methodChip}
                                                />
                                                <Typography className={classes.endpointPath}>
                                                    {endpoint.path}
                                                </Typography>
                                                <Box flexGrow={1} />
                                                <Typography variant="body2" color="textSecondary">
                                                    {endpoint.title}
                                                </Typography>
                                            </Box>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box width="100%">
                                                <Typography variant="body2" paragraph>
                                                    {endpoint.description}
                                                </Typography>

                                                {endpoint.example && (
                                                    <>
                                                        <Typography variant="subtitle2" gutterBottom>
                                                            <strong>Exemplo de Request Body:</strong>
                                                        </Typography>
                                                        <div className={classes.codeBlock}>
                                                            {JSON.stringify(endpoint.example, null, 2)}
                                                        </div>
                                                        <Button
                                                            size="small"
                                                            startIcon={<FileCopy />}
                                                            onClick={() => handleCopyExample(endpoint.example)}
                                                        >
                                                            Copiar Exemplo
                                                        </Button>
                                                    </>
                                                )}

                                                <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16 }}>
                                                    <strong>Exemplo de cURL:</strong>
                                                </Typography>
                                                <div className={classes.codeBlock}>
                                                    {`curl --request ${endpoint.method} \\
  --url ${backendUrl}${endpoint.path} \\
  --header 'Content-Type: application/json' \\
  --header '${endpoint.method === "GET" && endpoint.path.startsWith("/integrations") ? "Authorization: Bearer SEU_JWT_TOKEN" : `token: ${tokens.length > 0 ? tokens[0].token : 'SEU_TOKEN_AQUI'}`}'${endpoint.example ? `\n  --data '${JSON.stringify(endpoint.example, null, 2)}'` : ''}`}
                                                </div>

                                                {endpoint.responseExample && (
                                                    <>
                                                        <Typography variant="subtitle2" gutterBottom style={{ marginTop: 16 }}>
                                                            <strong>Exemplo de Resposta (200 OK):</strong>
                                                        </Typography>
                                                        <div className={classes.codeBlock}>
                                                            {JSON.stringify(endpoint.responseExample, null, 2)}
                                                        </div>
                                                        <Button
                                                            size="small"
                                                            startIcon={<FileCopy />}
                                                            onClick={() => handleCopyExample(endpoint.responseExample)}
                                                        >
                                                            Copiar Resposta
                                                        </Button>
                                                    </>
                                                )}
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Box>
                        ))}
                    </Box>
                </TabPanel>
            </Paper>

            {/* Create Token Dialog */}
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Criar Novo Token</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Nome do Token"
                        fullWidth
                        value={tokenName}
                        onChange={(e) => setTokenName(e.target.value)}
                        placeholder="Ex: Integração Site"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>
                        Cancelar
                    </Button>
                    <Button onClick={handleCreateToken} color="primary" variant="contained">
                        Criar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                >
                    {snackbar.message}
                </MuiAlert>
            </Snackbar>
            <br />
        </MainContainer>
    );
};

export default ApiDzapy;
